export default __webpack_public_path__ + "static/pillars-energy-440361f8137adff9e045c714b13eafdb.png";